import { textToDates } from "../../../../utilities/textToDate";
export function categorizeInformer(section, results) {
    const title = section.title.toLowerCase();
    if (title.indexOf("date") > -1 ||
        title.indexOf("news") > -1 ||
        title.indexOf("event") > -1) {
        section.parsedItems = textToDates(section.items, results.reference);
        results.events = section;
    }
    else if (title.indexOf("prayer") > -1) {
        results.prayerlist = section;
    }
    else if (title.indexOf("group meeting") > -1) {
        results.group = section;
    }
}
